
import Vue from 'vue'
// import HelloWorld from '@/ui/components/HelloWorld.vue';

export default Vue.extend({
  name: 'App',

  // components: {
  //   HelloWorld,
  // },

  data: () => ({
    //
  }),

  created() {
    document.addEventListener(
      'swUpdated',
      (e: CustomEventInit<ServiceWorkerRegistration>) => {
        this.$store.commit('sw/updateExists', e.detail)
      },
      { once: true }
    )

    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (this.$store.state.sw.refreshing) return
        this.$store.commit('sw/setRefreshing', true)
        window.location.reload()
      })
    }
  },
})
